; (function (inovestor, undefined) {
    // Setup dependencies for this plugin
    // Normally we would add jQuery and knockout but ms-core, which we depend on, already register them so it's useless

    // Create plugin namespace with any desired config variable
    inovestor.ms.comparator = inovestor.ms.comparator || {};
})(inovestor);
; (function (comparator, undefined) {
    // Create plugin namespace with any desired config variable
    comparator.config = {
        apiRelativeUrl: 'etfs/etfcomparatorV2?symbols={symbols}',
        apiDailyPricesRelativeUrl: 'etfs/etfComparatorV2/dailyPrices?symbols={symbols}',
        apiMonthlyReturnsRelativeUrl: 'etfs/etfComparatorV2/monthlyReturns?symbols={symbols}'
    };
})(inovestor.ms.comparator);


; (function (comparator, undefined) {
    var stateCacheKey = 'inoMsComparator';

    // Create plugin namespace with any desired config variable
    comparator.stateCache = {
        get: function () {
            try {
                var stateCacheFromStorage = sessionStorage.getItem(stateCacheKey);
                if (stateCacheFromStorage != null) {
                    var stateCache = JSON.parse(stateCacheFromStorage);
                    if (stateCache != null) {
                        return stateCache
                    }
                }
            } catch (e) {
                console.error(e);
            }
            return null
        },

        set: function (state) {
            try {
                sessionStorage.setItem(stateCacheKey, JSON.stringify(state));
            } catch (e) {
                console.error(e);
            }
        }
    };
})(inovestor.ms.comparator);


(function ($, ko, inovestor, undefined) {
    inovestor.ms.comparator.viewModels = {};

    /**
     * ViewModel for the ETF Comparison page
     * 
     * @constructor
     * @param {object} plugin - A handle to the ETF Comparison plugin
     */
    inovestor.ms.comparator.viewModels.comparatorViewModel = function (plugin) {

        var self = this;
        self.maxSymbols = plugin.options.maxSymbols;
        self.pdfReportUrl = plugin.options.pdfReportUrl;
        self.pdfHandler = plugin.options.pdfHandler;
        self.etfs = ko.observableArray([]);   // Gives you a handle to all the ETFs that are returned by the server
        self.resources = ko.observable();   // The resouces object for the current language
        self.rows = ko.observableArray();   // All of the formatted rows for the ETFs. Used to make the tables
        self.symbols = ko.observableArray();    // Collection of just the symbols. Passed to the plugin's search()
        self.tickers = ko.observableArray()  // Holds the tickers
        self.hasError = ko.observable(false);   // Boolean if there is an error with the data
        self.isBusy = ko.observable(false);     // Boolean if there is currently an AJAX call happening
        self.showCategoryAlert = ko.observable(false);  // Boolean whether we show the Caregory alert
        self.isInvalidIdentifier = ko.observable(false);
        self.invalidSymbols = ko.observable({
            symbols: ko.observableArray([]),
            displaySymbols: ko.observableArray([])
        });
        self.showInvalidSymbolsAlert = ko.observable(false);
        self.isDummyData = ko.observable(false);
        self.isFirstLoad = ko.observable(true);
        self.hasChartError = ko.observable(false);
        self.asOfPerfomanceDate = ko.observable();
        self.plugin = plugin;
        self.hasValidData = ko.computed(function () {
            return !self.hasError() && !self.isInvalidIdentifier() && self.etfs() !== null;
        }, this);

        self.canAddMoreSymbol = ko.pureComputed(function () {
            return self.symbols().filter(function (x) { return x.symbol !== plugin.options.defaultValueString }).length < self.maxSymbols;
        });

        self.numberOfSymbolsToCompare = ko.pureComputed(function () {
            return self.symbols().filter(function (x) { return x.symbol !== plugin.options.defaultValueString }).length;
        });

        // Observable to handle hidden/showing the collapsible sections
        self.hiddenOverview = ko.observable(false);
        self.hiddenOverviewCharacteristics = ko.observable(false);
        self.hiddenOverviewRisk = ko.observable(false);
        self.hiddenOverviewFixedIncome = ko.observable(false);
        self.hiddenPerformance = ko.observable(false);
        self.hiddenPerformancePeriodicReturns = ko.observable(false);
        self.hiddenPerformanceCalendarReturns = ko.observable(false);
        self.hiddenAllocations = ko.observable(false);
        self.hiddenAllocationsAssets = ko.observable(false);
        self.hiddenAllocationsGeographic = ko.observable(false);
        self.hiddenAllocationsSectors = ko.observable(false);
        self.hiddenAllocationsConstituents = ko.observable(false);

        // Observables related to the comparison chart
        self.displayComparisonChart = ko.observable(false);
        self.selectedComparisonChartPeriod = ko.observable('commonInception');
        self.selectedComparisonChartPeriodLength = ko.observable(null);
        self.setComparisonChartExtremes = function (period, periodLength) {
            self.selectedComparisonChartPeriod(period);
            self.selectedComparisonChartPeriodLength(periodLength);
            self.plugin._setChartExtremes(period, periodLength);
        }
        var comparisonChartTypes = ['returns', 'prices'];
        self.comparisonChartTypes = ko.observableArray(comparisonChartTypes);
        self.selectedComparisonChartType = ko.observable(comparisonChartTypes[0]);
        self.setSelectedComparisonChartType = function (type) {
            self.selectedComparisonChartType(type);
            self.plugin._renderComparisonChart(self.symbols());
        }

        /**
         * Sets the resources Observable to the corresponding one for the 
         * current language of the page
         */
        self.updateResources = function () {
            // Update main resources
            var currentResource = inovestor.ms.comparator.resources[inovestor.ms.core.currentLanguage];
            if (inovestor.ms.core.isNullOrUndefined(currentResource))
                currentResource = null;
            self.resources(currentResource);
        };

        self.haveDifferentCategories = ko.pureComputed(function () {
            var assetClassNameRow = self.rows().find(function (x) { return x.rowName === 'assetClassName' });
            if (assetClassNameRow == null) return false;
            var distinctCategories = assetClassNameRow.columns.map(function (x) { return x.valueEn }).filter(function (x) { return x !== self.plugin.options.defaultValueString }).filter(function (x, i, array) { return array.indexOf(x) === i });
            return distinctCategories.length > 1;
        });

        /**
         * Computed observable to return an observable array for the rows
         * in the 'Overview' section of the plugin
         * 
         * @returns {ObservableArray} - Collection of the Overview rows
         */
        self.overviewRows = ko.computed(function () {
            var rows = [],
                overviewRows = inovestor.ms.comparator.overviewRows,
                currentRows = self.rows();

            for (var i = 0; i < overviewRows.length; i++) {
                var currentOverview = overviewRows[i];

                for (var j = 0; j < currentRows.length; j++) {
                    var currentRow = currentRows[j];

                    if (currentRow.rowName === currentOverview) {
                        rows.push(currentRow);
                        break;
                    }
                }
            }

            return rows;
        });

        /**
         * Computed observable to return an observable array for the rows
         * in the 'Overview Risk' section of the plugin
         * 
         * @returns {ObservableArray} - Collection of the Overview Risk rows
         */
        self.riskRows = ko.computed(function () {
            var rows = [],
                riskRows = inovestor.ms.comparator.riskRows,
                currentRows = self.rows();

            for (var i = 0; i < riskRows.length; i++) {
                var currentField = riskRows[i];

                for (var j = 0; j < currentRows.length; j++) {
                    var currentRow = currentRows[j];

                    if (currentRow.rowName === currentField) {
                        rows.push(currentRow);
                        break;
                    }
                }
            }

            return rows;
        });

        /**
         * Computed observable to return an observable array for the rows
         * in the 'Overview Fixed Income' section of the plugin
         * 
         * @returns {ObservableArray} - Collection of the Overview Fixed Income rows
         */
        self.fixedIncomeRows = ko.computed(function () {
            var rows = [],
                fixedIncomeRows = inovestor.ms.comparator.fixedIncomeRows,
                currentRows = self.rows();

            for (var i = 0; i < fixedIncomeRows.length; i++) {
                var currentField = fixedIncomeRows[i];

                for (var j = 0; j < currentRows.length; j++) {
                    var currentRow = currentRows[j];

                    if (currentRow.rowName === currentField) {
                        rows.push(currentRow);
                        break;
                    }
                }
            }

            return rows;
        });

        /**
         * Removes all the values from the rows observable array for the
         * fund at the index.
         * 
         * @param {number} index - The index to remove
         */
        self.removeFromRowsByIndex = function (index) {
            if (!inovestor.ms.core.isNullOrUndefined(index)) {
                var rows = self.rows();

                for (var i = 0; i < rows.length; i++) {
                    var currentRow = rows[i];

                    if (currentRow.displayType !== 'localizedText') {
                        currentRow.columns[index] = { value: self.plugin.options.defaultValueString };
                    } else {
                        currentRow.columns[index] = { valueEn: self.plugin.options.defaultValueString, valueFR: self.plugin.options.defaultValueString };
                    }
                }

                self.rows([]);
                self.rows(rows);
            }
        };

        

        /**
         * Replaces a symbol (MIC:TICKER) in the symbol ObservableArray
         * 
         * @param {object} symbolObj - Holds the properties for the selected symbol
         * @param {number} symbolToChange - The index of the symbol to be changed
         */
        self.addSymbol = function (symbolObj) {
            if (!inovestor.ms.core.isNullOrUndefined(symbolObj)
                && !inovestor.ms.core.isNullOrUndefined(symbolObj.symbol)) {

                // Check if the symbol that we are trying to add is already in the list
                if (self.symbols().some(function (x) { return symbolObj.symbol === x.symbol; })) return; // don't add the same symbol more than one time

                // Find the first index that is empty and that we are able to add the symbol into
                const symbolToChange = self.symbols().findIndex(function (x) { return x.symbol === self.plugin.options.defaultValueString; });
                if (symbolToChange === -1) return; // there is no empty slot

                // Depending on which input was used set the right symbol
                self.symbols.replace(self.symbols()[symbolToChange],
                    { symbol: symbolObj.symbol, isValidTicker: false });

                var ticker = symbolObj.symbol.substring(symbolObj.symbol.indexOf(':') + 1);
                self.tickers()[symbolToChange] = ticker;
                // Force a refresh
                self.tickers(self.tickers());

                self.doSearch();
            }
        },

            /**
             * Remove a symbol from the symbols collection and replaces it with
             * an empty symbol before calling the plugin's search()
             * 
             * @param {number} index - The index to remove
             */
            self.removeSymbol = function (index) {
                if (!inovestor.ms.core.isNullOrUndefined(index) &&
                    index <= self.symbols().length - 1 &&
                    !self.isBusy()) {

                    var symbols = self.symbols();
                    var tickers = self.tickers();
                    var etfs = self.etfs();

                    var numberOfWantedSymbols = symbols.length

                    symbols.splice(index, 1);
                    tickers.splice(index, 1);
                    etfs.splice(index, 1);

                    symbols = symbols.filter(function (x) { return x.isValidTicker })
                    tickers = tickers.filter(function (x) { return x !== self.plugin.options.defaultValueString })
                    etfs = etfs.filter(function (x) { return x.dummyData !== true })

                    for (var i = symbols.length; i < numberOfWantedSymbols; i++) {
                        symbols.push({ symbol: self.plugin.options.defaultValueString, isValidTicker: false });
                        tickers.push(self.plugin.options.defaultValueString);
                        etfs.push({ symbol: self.plugin.options.defaultValueString, dummyData: true });
                    }

                    // Force refresh
                    self.symbols(symbols);
                    self.tickers(tickers);
                    self.etfs(etfs);
                    self.removeFromRowsByIndex(index);

                    var rows = self.plugin._createRows(self.etfs());
                    self.rows(self.plugin._formatRows(rows));

                    self.plugin._renderComparisonChart(plugin._viewModel.symbols());
                    self.plugin._renderPieCharts();
                    self.plugin._setUrlValues();
                }
            },

            /**
             * Calls the plugin's search() function passing into it a comma
             * separated list of all the symbols
             */
            self.doSearch = function () {
                var arr = [];

                for (var i = 0; i < self.symbols().length; i++) {
                    if (self.symbols()[i].symbol !== self.plugin.options.defaultValueString)
                        arr.push(self.symbols()[i].symbol);
                }
                self.plugin.search(arr.join(','));
            }

        self.urlValues = ko.observableArray();
        self.selfUrl = ko.observable();

        self.exportToCsv = function () {
            try {
                var csvArray = inovestor.ms.comparator.csvService.transformComparatorDataToCsvArray(self.etfs().filter(function (x) { return x.dummyData !== true }), self.resources());
                var csvString = inovestor.ms.comparator.csvService.transformCsvArrayToCsvString(csvArray, { escapeHeader: true });
                var blob = new Blob([csvString], { type: "text/csv;charset=utf-8" });
                saveAs(blob, inovestor.ms.core.currentLanguage === 'fr' ? 'Comparaison des fonds.csv' : 'Fund Comparison.csv');
            } catch (error) {
                console.error(error);
                $('#ino-ms-etf-comparator-csv-export-error-modal').modal('show');
            }
        };

        self.generatePdfUrl = function () {
            var symbols = self.etfs().filter(function (x) { return x.dummyData !== true }).map(function (x) { return x.symbol });
            var url = inovestor.ms.core.stringFormat(self.pdfReportUrl, { symbols: symbols.join(',') });
            return url;
        };

        self.getSymbolAtIndex = function (index) {
            var validEtfs = self.etfs().filter(function (x) { return x.dataType !== null });
            if (index < validEtfs.length) {
                var validEtf = validEtfs[index];
                return validEtf.dataType === 'fund' ? validEtf.symbol : validEtf.ticker ;
            }
            return null;
        }

        self.canLink = function (data) {
            if (data == null || inovestor.ms.core.isEmptyString(data.family) || inovestor.ms.core.isEmptyString(plugin.options.redirectUrl)) return false

            if (plugin.options.sponsoredFamilies == null || plugin.options.sponsoredFamilies.length === 0) return true

            return plugin.options.sponsoredFamilies.some(function (x) {
                return x.localeCompare(data.family, 'en', { sensitivity: 'base' }) === 0
            })
        }

        self.generateLink = function (data) {
            if (data == null || inovestor.ms.core.isEmptyString(plugin.options.redirectUrl)) return ''
            return inovestor.ms.core.stringFormat(plugin.options.redirectUrl, { symbol: data.symbol, category: data.dataType })
        }

        // we only want to use the library for english language
        // the default browser hyphenation is good enough for french
        var hyphenate = inovestor.ms.core.currentLanguage === 'en' ? createHyphenator(hyphenationPatternsEnUs) : function (text) { return text }
        self.hyphenate = function (text) {
            if (text == null) return text
            return hyphenate(text)
        }

        self.coalesce = function (value, defaultValue) {
            if (value == null) return defaultValue
            return value
        }
    }
})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);

; (function ($, ko, inovestor, undefined) {

    var pluginName = 'inoMsComparator';
    
    /**
     * Plugin constructor for the ETF Comparison page
     * 
     * @constructor
     * @param {object} element - The DOM element the plugin is attached to
     * @param {object} options - The options for the plugin
     */
    function Plugin(element, options) {

        this.element = element;
        this._name = pluginName;
        this._defaults = $.fn.inoMsComparator.defaults;

        // Merge options with defaults
        this.options = $.extend(true, {}, this._defaults, options);

        this._viewModel = new inovestor.ms.comparator.viewModels.comparatorViewModel(this);

        // Make sure required variables are set
        if (inovestor.ms.core.isNullOrUndefined(this.options.symbols))
            throw "at least 1 symbol required";

        this.comparisonChartData = null;
        this.comparisonChartInstance = null;
        this.comparisonChartReturnsCache = new Map();
        this.comparisonChartPricesCache = new Map();

        // Call init
        this.init();
    }

    /**
     * Avoid Plugin.prototype conflicts
     */
    $.extend(Plugin.prototype, {

        /**
         * Initialization logic for the plugin
         */
        init: function () {
            var plugin = this;

            // Setup what plugin needs to do on language change
            inovestor.ms.core.instances.register(this, function () {
                plugin.update();
            });

            // Plugin overrides for template = cacheKey and path are the same
            var fileCacheKey = plugin.options.templatePaths.comparator;
            var filePath = plugin.options.templatePaths.comparator;
            // Default behavior (if no template path is set by plugin)
            if (inovestor.ms.core.isEmptyString(fileCacheKey)) {
                var fileName = 'comparator.html';
                fileCacheKey = pluginName + '.' + fileName;
                filePath = (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) ? '' : inovestor.ms.core.config.templateRootUrl) +
                    (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) || inovestor.ms.core.config.templateRootUrl.match(/\/$/) != null ? '' : '/') + // check if templateRootUrl ends in slash
                    (this._name + '/' + fileName);
            }

            // Get main template file
            inovestor.ms.core.getTemplate(fileCacheKey, filePath).then(function (template) {
                $(plugin.element).html(template);
                plugin.buildCache();
                plugin.render();
                plugin.bindEvents();
                plugin.bindModel();
            }).then(function () {
                // Set up Shareable
                plugin.shareable = new inovestor.ms.core.Shareable();
                plugin._setInitialSymbols();

                // Set the symbols for the view model
                plugin._setTickers(plugin.options.maxSymbols);

                // Get the autocomplete widget if none loaded
                if (!$.ui) {
                    if (inovestor.ms.core.isNullOrUndefined(plugin.options.inoCdnBaseUrl))
                        throw "inoCdnBaseUrl is required";

                    var jUIScriptUrl = inovestor.ms.core.concatUrl(plugin.options.inoCdnBaseUrl, 'dist/libs/jquery-ui/jquery-ui-1.14.1/jquery-ui.min.js');
                    var jUIStyleUrl = inovestor.ms.core.concatUrl(plugin.options.inoCdnBaseUrl, 'dist/libs/jquery-ui/jquery-ui-1.14.1/jquery-ui.min.css');

                    $('body').append('<script type="text/javascript" src="' + jUIScriptUrl + '"></script>')
                    $('body').append('<link rel="stylesheet" href="' + jUIStyleUrl + '"></link>')
                }
                else if (inovestor.ms.core.isNullOrUndefined($.ui.autocomplete))
                    throw 'jQuery IU autocomplete module is required';

                var autocomplete = inovestor.ms.autocomplete;
                if (!autocomplete) {
                    if (inovestor.ms.core.isNullOrUndefined(plugin.options.inoCdnBaseUrl))
                        throw "inoCdnBaseUrl is required";

                    var autocompleteScriptUrl = inovestor.ms.core.concatUrl(plugin.options.inoCdnBaseUrl, 'widgets/inoMsAutocomplete/inoMsAutocomplete-3.0.0.min.js');
                    var autocompleteStyleUrl = inovestor.ms.core.concatUrl(plugin.options.inoCdnBaseUrl, 'widgets/inoMsAutocomplete/inoMsAutocomplete-3.0.0.min.css');
                    $('body').append('<script type="text/javascript" src="' + autocompleteScriptUrl + '"></script>');
                    $('body').append('<link rel="stylesheet" href="' + autocompleteStyleUrl + '"></link>');
                }

                plugin._setUpAutocomplete(); // Allow to use AutoComplete even there is no symbols 

                // Call Search
                plugin.search(plugin.options.symbols).always(function () {
                    plugin._setUpAutocomplete();
                    // When search is completed, trigger onReady event
                    plugin.$element.trigger('ready' + '.' + plugin._name);
                });
            });
        },

        _setInitialSymbols: function () {
            var plugin = this;

            // first try to set the symbols from the URL
            var urlValues = plugin.shareable.getNavigationValues();
            if (!inovestor.ms.core.isNullOrUndefined(urlValues.symbols)) {
                var nonEmptyUrlSymbols = plugin._removeEmptySymbols(urlValues.symbols);
                if (nonEmptyUrlSymbols.length > 0) {
                    plugin.options.symbols = nonEmptyUrlSymbols;
                    plugin._removeDuplicateSymbols(plugin.options.symbols);
                    return
                }
            }

            // if symbols are not in the URL, try to set them from the state cache
            var stateCacheValues = inovestor.ms.comparator.stateCache.get()
            if (stateCacheValues != null && stateCacheValues.symbols != null) {
                var nonEmptyStateCacheSymbols = plugin._removeEmptySymbols(stateCacheValues.symbols);
                plugin.options.symbols = nonEmptyStateCacheSymbols;
                plugin._removeDuplicateSymbols(plugin.options.symbols);
                return
            }
        },

        /**
         * Sets the ticker values in the view model for the inputs
         * 
         * @param {number} maxSymbols - The maximum number of symbols to compare
         */
        _setTickers: function (maxSymbols) {
            var plugin = this;

            if (inovestor.ms.core.isNullOrUndefined(maxSymbols))
                maxSymbols = 5;
            if (!inovestor.ms.core.isNullOrUndefined(plugin.options.symbols)) {
                var tickers = plugin.options.symbols.split(',').map(function (symbol) {
                    return symbol.substring(symbol.indexOf(':') + 1);
                })

                // Make sure we always have the right number of tickers
                while (tickers.length !== maxSymbols) {
                    tickers.push(plugin.options.defaultValueString);
                }

                plugin._viewModel.tickers(tickers);
            }
        },

        /**
         * Removes the plugin instance completely
         */
        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        /**
         * Caches the DOM nodes for performance
         */
        buildCache: function () {
            this.$element = $(this.element);
            this.$etfChartInstance = null;
        },

        /**
         * Bind events for the plugin
         */
        bindEvents: function () {
            var plugin = this;
            plugin.$element.on('ready' + '.' + plugin._name, function () {
                var onReady = plugin.options.onReady;
                if (typeof onReady === 'function')
                    onReady.call(plugin.$element);
            });

            plugin.$element.find('.ino-etf-compare__share-btn-group').on('show.bs.dropdown', function () {
                var input = plugin.$element.find('.ino-etf-compare__share-dropdown-menu input')
                input.val(location.href)
                setTimeout(function () {
                    input.select()
                    try {
                        document.execCommand('copy')
                    } catch (e) {
                        console.error(e)
                    }
                })
            })

            $(document).on('browser-navigation-hashchange', function () {
                
                // Reset invalid symbols
                plugin._viewModel.invalidSymbols().symbols([]);
                plugin._viewModel.showInvalidSymbolsAlert(false);


                // Get old symbols and new symbols
                var oldSymbols = plugin._getValidSymbolString();
                plugin._setInitialSymbols();

                if (oldSymbols.join(',').toLowerCase() === plugin.options.symbols)
                    return;

                if (plugin.options.symbols) {
                    var newSymbolsArr = plugin.options.symbols.split(',');
                    while (newSymbolsArr.length < plugin.options.maxSymbols)
                        newSymbolsArr.push(plugin.options.defaultValueString);

                    // Don't let user put too many symbols in URL
                    var extraSymbols = newSymbolsArr.splice(plugin.options.maxSymbols);

                    extraSymbols.forEach(function (item) {
                        plugin._viewModel.invalidSymbols().symbols().push({
                            symbol: item,
                            reason: 'tooManySymbols'
                        });
                    });

                    if (extraSymbols.length > 0)
                        plugin.options.symbols = newSymbolsArr.join(',');

                    var areSameSymbols = plugin._areSymbolsTheSame(newSymbolsArr, oldSymbols);
                    if (areSameSymbols) {

                        var id = 0;
                        // Find which symbol moved
                        while ((oldSymbols[id] === newSymbolsArr[id] || oldSymbols[id] === newSymbolsArr[id + 1]) && id < oldSymbols.length) {
                            id++;
                        }

                        if (id < oldSymbols.length) {
                            var newIndex = id;
                            var oldIndex = oldSymbols.indexOf(newSymbolsArr[newIndex]);
                            plugin._swapValuesByIndices(oldIndex, newIndex);
                        } else {
                            plugin.shareable.setNavigation({ symbols: plugin.options.symbols.toUpperCase() });
                        }

                        if (plugin._viewModel.invalidSymbols().symbols().length > 0) {
                            plugin._viewModel.invalidSymbols().displaySymbols(plugin._viewModel.invalidSymbols().symbols());
                            plugin._viewModel.showInvalidSymbolsAlert(true);
                        }
                    } else {
                        plugin._setTickers(plugin.options.maxSymbols);
                        plugin.search(plugin.options.symbols);
                    }
                }
            });
        },

        _getValidSymbolString: function () {
            var plugin = this;

            var oldSymbols = [];
            for (var i = 0; i < plugin._viewModel.symbols().length; i++) {
                var currentVal = plugin._viewModel.symbols()[i].symbol;

                if (currentVal !== plugin.options.defaultValueString)
                    oldSymbols.push(currentVal.toLowerCase());
            }

            return oldSymbols;
        },

        _areSymbolsTheSame: function (newSymbolsArr, oldSymbols) {
            var sameSymbols = true;
            for (var i = 0; i < newSymbolsArr.length; i++) {
                var currentSymbol = newSymbolsArr[i];

                if (oldSymbols.indexOf(currentSymbol) === -1) {
                    var sameSymbols = false;
                    break;
                }
            }

            return sameSymbols;
        },

        /**
         * Unbind events for the plugin
         */
        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        // API error handler
        apiErrorHandler: function (apiError) {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.apiError, apiError, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.hasError(true);
        },

        /**
         * Handles the invalid identifier response from the server
         */
        invalidIdentifierHandler: function () {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.invalidIdentifier, null, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.isInvalidIdentifier(true);
        },

        /**
         * Calls the API and searches for the provided symbols
         * 
         * @param {string} symbols - A comma seperated list of symbols (MIC:TICKER)
         * @returns {Deferred} - The call to the server for the symbols
         */
        search: function (symbols) {
            var plugin = this;

            plugin._resetDataBeforeSearch();

            plugin.options.symbols = symbols;

            // Fill the table anyway when there's no symbols
            if (inovestor.ms.core.isEmptyString(plugin.options.symbols)) {
                plugin._viewModel.isFirstLoad(false); // Show Comparison Tool panel even if there is no symbol
                plugin._viewModel.etfs([]);
                plugin._viewModel.symbols([]);
                return plugin._setDefaultTable();
            }

            // Setup API url with term
            var etfUrl = inovestor.ms.core.stringFormat(inovestor.ms.comparator.config.apiRelativeUrl, { symbols: plugin.options.symbols });

            // Call API and bind model
            var options = { type: 'GET', contentType: 'application/json', error: function (error) { plugin.apiErrorHandler(error); } };
            return inovestor.ms.core.ajaxApi(etfUrl, options).then(function (data) {
                if (!inovestor.ms.core.isNullOrUndefined(data)) {

                    var validData = plugin._removeInvalidSymbols(data);

                    if (plugin._viewModel.invalidSymbols().symbols().length > 0) {
                        plugin._viewModel.showInvalidSymbolsAlert(true);
                        plugin._viewModel.invalidSymbols().displaySymbols(
                            plugin._viewModel.invalidSymbols().symbols());
                    }

                    plugin._addFundsAndSymbolsToVM(validData);
                    plugin._sortResults();
                    plugin._fillTableData(plugin._viewModel.etfs(), plugin.options.maxSymbols);
                    plugin._setUrlValues();
                    var rows = plugin._createRows(plugin._viewModel.etfs());
                    plugin._viewModel.rows(plugin._formatRows(rows));
                    plugin._renderComparisonChart(plugin._viewModel.symbols());
                    plugin._renderPieCharts();
                    plugin._viewModel.isFirstLoad(false);
                }
                else {
                    plugin._viewModel.etfs([]);
                }

                plugin._viewModel.invalidSymbols().symbols([]);
                plugin._setUpSortable();
                plugin._viewModel.isBusy(false);
            });
        },

        _addFundsAndSymbolsToVM: function (validData) {
            var plugin = this;

            plugin._viewModel.etfs([]);
            plugin._viewModel.symbols([]);
            for (var i = 0; i < validData.length; i++) {
                if (validData[i].dataType === 'fund' && validData[i].assetUnderManagement) {
                    validData[i].assetUnderManagement = validData[i].assetUnderManagement * 1000000;
                }

                plugin._viewModel.etfs.push(validData[i]);
                plugin._viewModel.symbols.push({ symbol: validData[i].symbol, isValidTicker: true });
            }
        },

        _removeInvalidSymbols: function (data) {
            var plugin = this;

            var badIndices = [];
            data.forEach(function (item, index, array) {
                if (item.requestStatus === 'invalidIdentifier' || item.requestStatus === 'invalid') {
                    plugin._viewModel.invalidSymbols().symbols.push({
                        symbol: item.symbol,
                        reason: 'invalidSymbol'
                    });

                    badIndices.push(index);
                }
            });

            badIndices.reverse().forEach(function (value) {
                data.splice(value, 1);
            });

            return data;
        },

        _resetDataBeforeSearch: function () {
            var plugin = this;
            plugin._viewModel.hasError(false);
            plugin._viewModel.isInvalidIdentifier(false);
            plugin._viewModel.isBusy(true);
            plugin._viewModel.showCategoryAlert(false);
            plugin._viewModel.isDummyData(false);
            plugin._viewModel.displayComparisonChart(false);
            plugin._viewModel.showInvalidSymbolsAlert(false);
        },

        _removeDuplicateSymbols: function (symbols) {
            var plugin = this;
            var duplicateSymbols = [];

            if (!inovestor.ms.core.isEmptyString(symbols)) {
                var symbolArr = symbols.toLowerCase().split(',');
                duplicateSymbols = symbolArr.filter(function (item, index, self) {
                    return index !== self.lastIndexOf(item);
                });

                var uniqueSymbols = symbolArr.filter(function (item, index, self) {
                    return self.indexOf(item) === index;
                });

                plugin.options.symbols = uniqueSymbols.join();
            }

            duplicateSymbols.forEach(function (item) {
                plugin._viewModel.invalidSymbols().symbols.push({
                    symbol: item,
                    reason: 'duplicateSymbol'
                });
            });
        },

        _removeEmptySymbols: function (symbols) {
            var plugin = this;
            var newSymbolStr = '';

            if (!inovestor.ms.core.isEmptyString(symbols)) {
                var symbolsArr = symbols.split(',').filter(function (item) {
                    return !inovestor.ms.core.isEmptyString(item) && item !== plugin.options.defaultValueString;
                });

                newSymbolStr = symbolsArr.join();
            }

            return newSymbolStr;
        },

        /**
         * Sets up the default table when there's an error with the symbols or the data returned from
         * the server
         * 
         * @returns {Deferred} - A done state on an empty deferred
         */
        _setDefaultTable: function () {
            var plugin = this;
            plugin._fillTableData(plugin._viewModel.etfs(), plugin.options.maxSymbols);
            var unformattedRows = plugin._createRows(plugin._viewModel.etfs());
            plugin._viewModel.rows(plugin._formatRows(unformattedRows));
            plugin.update();
            plugin._viewModel.isBusy(false);
            return $.Deferred().done();
        },

        _setUrlValues: function () {
            var plugin = this;
            var etfs = plugin._viewModel.etfs();
            var validSymbols = [];
            var symbolObj = {};

            for (var i = 0; i < etfs.length; i++) {
                etfs[i].symbol !== plugin.options.defaultValueString ? validSymbols.push(etfs[i].symbol) : null;
            }

            if (validSymbols.length > 0) {
                symbolObj.symbols = validSymbols.join();
                var currentUrlValues = plugin.shareable.getNavigationValues().symbols;

                if (!inovestor.ms.core.isNullOrUndefined(currentUrlValues)) {

                    if (currentUrlValues.toLowerCase() !== symbolObj.symbols.toLowerCase())
                        plugin.shareable.setNavigation(symbolObj);

                } else {
                    plugin.shareable.setNavigation(symbolObj);
                }

                inovestor.ms.comparator.stateCache.set({ symbols: validSymbols.join(',') })
            } else {
                plugin.shareable.setNavigation({});
                inovestor.ms.comparator.stateCache.set({ symbols: '' });
            }
        },

        _swapValuesByIndices: function (oldIndex, newIndex) {
            var plugin = this;
            var tickers = plugin._viewModel.tickers();
            var symbols = plugin._viewModel.symbols();
            var etfs = plugin._viewModel.etfs();
            var rows = plugin._viewModel.rows();

            // Ticker, Symbols and ETFs all include dummy data for empty slots (always five items for 5 symbols configured comparison)
            // Rows columns don't include those dummy data (four columns if there is an empty slot for a symbol for a 5 symbols configured comparison)
            var adjustedOldIndexForRows = Math.min(oldIndex - tickers.filter(function (x, i) { return x === plugin.options.defaultValueString && i < oldIndex; }).length, rows[0].columns.length - 1);

            var moved = tickers[oldIndex];
            tickers.splice(oldIndex, 1);
            tickers.splice(newIndex, 0, moved);

            moved = symbols[oldIndex];
            symbols.splice(oldIndex, 1);
            symbols.splice(newIndex, 0, moved);

            moved = etfs[oldIndex];
            etfs.splice(oldIndex, 1);
            etfs.splice(newIndex, 0, moved);

            plugin._viewModel.tickers([]);
            plugin._viewModel.tickers(tickers);

            plugin._viewModel.symbols([]);
            plugin._viewModel.symbols(symbols);

            plugin._viewModel.etfs([]);
            plugin._viewModel.etfs(etfs);

            var adjustedNewIndexForRows = Math.min(newIndex - tickers.filter(function (x, i) { return x === plugin.options.defaultValueString && i < newIndex; }).length, rows[0].columns.length - 1);

            for (var i = 0; i < rows.length; i++) {
                var currentColumns = rows[i].columns;

                moved = currentColumns[adjustedOldIndexForRows];
                currentColumns.splice(adjustedOldIndexForRows, 1);
                currentColumns.splice(adjustedNewIndexForRows, 0, moved);

                rows[i].columns = currentColumns;
            }
            plugin._viewModel.rows([]);
            plugin._viewModel.rows(rows);

            plugin._renderComparisonChart(symbols);
            plugin._renderPieCharts();
            plugin._setUrlValues();
        },

        _setUpSortable: function () {
            var plugin = this;

            $("#ino-etf-ticker-container").sortable({
                handle: ".sortable-handle",
                scroll: true,
                placeholder: "ino-etf-ticker",
                helper: function (event, ui) {
                    var clone = ui.clone();
                    clone.css({
                        height: ui.height(),
                        width: ui.width(),
                    });
                    return clone;
                },
                update: function (event, ui) {
                    var oldIndex = ui.item.data('oldIndex');
                    var newIndex = ui.item.index();

                    if (oldIndex === newIndex) return;

                    
                    plugin._swapValuesByIndices(oldIndex, newIndex);
                    plugin._viewModel.showInvalidSymbolsAlert(false);
                },
                start: function (event, ui) {
                    //ui.placeholder -> Représente l'element qui reste en arriere lors du drag and drop
                    //ui.helper -> Represente l'element que la souris garde lors du drag and drop 
                    //ui.item -> Represente original qui doit bouger 

                    ui.item.data('oldIndex', ui.item.index()); // Manage the index while changing
                    ui.placeholder.html(ui.item.html()) // Faire que le placeholder ne sois pas different de l'element d'origine 
                },
                change: function (event, ui) {
                    ui.placeholder.html(ui.item.html()); // Mise à jour de la placeholder pour qu'elle soit identique à l'élément
                },
                stop: function (event, ui) {
                    ui.item.css('visibility', 'visible'); // Rendre l'élément visible à nouveau
                },
            })

            //This method converts mouse events into touch help when using mobile 
            // Because jquery-ui does not works good with in mobile 
            function touchHandler(event) {
                var touch = event.changedTouches[0];

                var simulatedEvent = document.createEvent("MouseEvent");
                simulatedEvent.initMouseEvent({
                    touchstart: "mousedown",
                    touchmove: "mousemove",
                    touchend: "mouseup"
                }[event.type], true, true, window, 1,
                    touch.screenX, touch.screenY,
                    touch.clientX, touch.clientY, false,
                    false, false, false, 0, null);

                touch.target.dispatchEvent(simulatedEvent);
            }

            document.addEventListener("touchstart", touchHandler, true)
            document.addEventListener("touchmove", touchHandler, true);
            document.addEventListener("touchend", touchHandler, true);
            document.addEventListener("touchcancel", touchHandler, true);
        },

        /**
         * Sorts the results returned by the server to make sure that the ordering
         * of the ETFs returned by the server matches the input boxes.
         */
        _sortResults: function () {
            var plugin = this;
            var etfs = plugin._viewModel.etfs();
            var symbols = plugin._viewModel.symbols();
            var tickers = plugin._viewModel.tickers();

            if (!inovestor.ms.core.isNullOrUndefined(tickers) && !inovestor.ms.core.isNullOrUndefined(etfs)
                && !inovestor.ms.core.isNullOrUndefined(symbols)) {

                var sortedEtfs = [];
                var sortedSymbols = [];

                // Sort symbols and etfs based on the order of the tickers
                for (var i = 0; i < tickers.length; i++) {
                    var ticker = tickers[i];

                    if (ticker === plugin.options.defaultValueString) {
                        sortedEtfs.push({ symbol: plugin.options.defaultValueString, dummyData: true });
                        sortedSymbols.push({ symbol: plugin.options.defaultValueString, isValidTicker: false });
                    } else {
                        for (var j = 0; j < etfs.length; j++) {
                            // Also compare on symbol for funds
                            if ((etfs[j].ticker && etfs[j].ticker.toLowerCase() === ticker.toLowerCase()) ||
                                (etfs[j].symbol && etfs[j].symbol.toLowerCase() === ticker.toLowerCase())) {
    
                                sortedEtfs.push(etfs[j]);
                                sortedSymbols.push(symbols[j]);
                                break;
                            }
                        }
                    }
                }

                plugin._viewModel.etfs(sortedEtfs);
                plugin._viewModel.symbols(sortedSymbols);
            }
        },

        /**
         * Fills all the empty ETF slots until the maximum number of ETFs
         * 
         * @param {array} etfs - Collection of all the etfs
         * @param {number} maxNumberOfEtfs - The maximum number of ETFs we want to compare
         */
        _fillTableData: function (etfs, maxNumberOfEtfs) {
            var plugin = this;
            var dummyCtr = 0;

            // Make sure we have the right number of ETFs (Should always have 2)
            while (etfs.length < maxNumberOfEtfs) {
                plugin._viewModel.etfs.push({ symbol: plugin.options.defaultValueString, dummyData: true });
                // Also make sure we have enough symbols
                plugin._viewModel.symbols.push({ symbol: plugin.options.defaultValueString, isValidTicker: false });
                dummyCtr++;
            }

            if (dummyCtr === maxNumberOfEtfs) {
                plugin._viewModel.isDummyData(true);
            }
        },

        /**
         * Creates the rows that are to be iterated over to display the comparison table
         * 
         * @param {array} etfs - Collection of all the etfs
         * @returns {array} rows - Collection of the rows
         */
        _createRows: function (etfs) {
            var plugin = this;
            var rowNames = inovestor.ms.comparator.rowNames;
            var rows = [];

            for (var i = 0; i < rowNames.length; i++) {
                var rowDefinition = rowNames[i];

                // Create the row object based on the definition
                var rowObj = {
                    rowName: rowDefinition.key,
                    displayType: rowDefinition.displayType,
                    resourceKey: rowDefinition.resourceKey,
                    columns: []
                };

                // Add the value for the feature for all the ETFs
                for (var j = 0; j < etfs.length; j++) {
                    var etf = etfs[j];

                    if (etf.symbol !== plugin.options.defaultValueString) {
                        var key = rowDefinition.key;

                        if (key === 'previousClose' && etf.dataType === 'fund')
                            key = 'previousNavps';

                        var columnValue = etf[key];
                        if (!inovestor.ms.core.isNullOrUndefined(columnValue)) {
                            rowObj.columns.push({ value: columnValue, decimalPlaces: rowDefinition.decimalPlaces, valueAsPercent: rowDefinition.valueAsPercent, showAsLargeNumber: rowDefinition.showAsLargeNumber });
                            // Check for English and French named values
                        } else if (rowDefinition.displayType === 'localizedText') {

                            rowObj.columns.push({
                                valueEn: etf[key + 'En'] || plugin.options.defaultValueString,
                                valueFr: etf[key + 'Fr'] || plugin.options.defaultValueString,
                            });
                        } else if (rowDefinition.displayType === 'localizedModalText') {
                            rowObj.columns.push({
                                value: inovestor.ms.core.currentLanguage === 'fr' ? etf[key + 'Fr'] || plugin.options.defaultValueString : etf[key + 'En'] || plugin.options.defaultValueString,
                                linkTextResourceKey: rowDefinition.linkTextResourceKey
                            });
                        } else {
                            rowObj.columns.push({ value: plugin.options.defaultValueString });
                        }
                    }
                }

                rows.push(rowObj);
            }

            return rows;
        },

        /**
         * Adds the CSS classes for the rows and formats the text to something we can display
         * on the page. 
         * 
         * @param {array} rows - Collection of all the rows for the page
         * @returns {array} - The formatted rows
         */
        _formatRows: function (rows) {
            var plugin = this;

            // Loop through to change the text
            if (rows.length > 0 && rows[0].columns.length > 0) {
                for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
                    var currentRow = rows[rowIndex];

                    // Check for different categories and display the alert
                    if (currentRow.rowName === 'assetClassName') {
                        var compareCol = currentRow.columns[0].valueEn;
                        for (var i = 1; i < currentRow.columns.length; i++) {
                            var comparer = currentRow.columns[i].valueEn;
                            if (comparer !== plugin.options.defaultValueString)
                                if (comparer !== compareCol)
                                    plugin._viewModel.showCategoryAlert(true);
                        }
                    }
                }
            }

            return rows;
        },

        // Renders html template and binds model (should be called once)
        render: function () {
            var plugin = this;
            plugin._viewModel.updateResources();
        },

        _setChartExtremes: function (type, count) {
            if (inovestor.ms.core.isNullOrUndefined(type))
                return;

            var plugin = this,
                apiFirstDate = null,
                apiLastDate = null,
                minDate = null,
                maxDate = null;

            if (!inovestor.ms.core.isNullOrUndefined(plugin.comparisonChartData) && plugin.comparisonChartData.length > 0) {
                // In all historicalDatas, find the max and min date and set them to apiFirstDate and apiLastDate
                plugin.comparisonChartData.forEach(function (chartData) {
                    if (!inovestor.ms.core.isNullOrUndefined(chartData.historicalDatas) && chartData.historicalDatas.length > 0) {
                        var firstDate = new Date(chartData.historicalDatas[0].date);
                        var lastDate = new Date(chartData.historicalDatas[chartData.historicalDatas.length - 1].date);

                        if (inovestor.ms.core.isNullOrUndefined(apiFirstDate) || firstDate < apiFirstDate)
                            apiFirstDate = firstDate;

                        if (inovestor.ms.core.isNullOrUndefined(apiLastDate) || lastDate > apiLastDate)
                            apiLastDate = lastDate;

                        plugin._viewModel.asOfPerfomanceDate(apiLastDate)
                    }
                });
            }

            // Make sure a date was found before setting the extremes
            if (inovestor.ms.core.isNullOrUndefined(apiFirstDate) || inovestor.ms.core.isNullOrUndefined(apiLastDate))
                return;

            switch (type) {
                case 'ytd':
                    maxDate = Date.UTC(apiLastDate.getUTCFullYear(), apiLastDate.getUTCMonth(), apiLastDate.getUTCDate(), apiLastDate.getUTCHours(), apiLastDate.getUTCMinutes(), apiLastDate.getUTCSeconds());
                    minDate = Date.UTC(apiLastDate.getUTCFullYear(), 0, 1, 0, 0, 0);
                    break;
                case 'all':
                    minDate = Date.UTC(apiFirstDate.getUTCFullYear(), apiFirstDate.getUTCMonth(), apiFirstDate.getUTCDate(), apiFirstDate.getUTCHours(), apiFirstDate.getUTCMinutes(), apiFirstDate.getUTCSeconds());
                    maxDate = Date.UTC(apiLastDate.getUTCFullYear(), apiLastDate.getUTCMonth(), apiLastDate.getUTCDate(), apiLastDate.getUTCHours(), apiLastDate.getUTCMinutes(), apiLastDate.getUTCSeconds());
                    break;
                case 'year':
                    maxDate = Date.UTC(apiLastDate.getUTCFullYear(), apiLastDate.getUTCMonth(), apiLastDate.getUTCDate(), apiLastDate.getUTCHours(), apiLastDate.getUTCMinutes(), apiLastDate.getUTCSeconds());

                    var minDateCompute = new Date(maxDate);
                    minDateCompute.setFullYear(minDateCompute.getFullYear() - count);

                    if (minDateCompute < apiFirstDate) {
                        minDateCompute = apiFirstDate;
                    }

                    minDate = Date.UTC(minDateCompute.getUTCFullYear(), minDateCompute.getUTCMonth(), minDateCompute.getUTCDate(), minDateCompute.getUTCHours(), minDateCompute.getUTCMinutes(), minDateCompute.getUTCSeconds());
                    break;
                case 'commonInception':
                    // In all historicalDatas, find the min start date and set is as the mostRecentDate
                    var mostRecentDate;

                    plugin.comparisonChartData.forEach(function (chartData) {
                        if (!inovestor.ms.core.isNullOrUndefined(chartData.historicalDatas) && chartData.historicalDatas.length > 0) {
                            var firstDate = new Date(chartData.historicalDatas[0].date);

                            if (inovestor.ms.core.isNullOrUndefined(mostRecentDate) || firstDate > mostRecentDate)
                                mostRecentDate = firstDate;
                        }
                    });

                    minDate = Date.UTC(mostRecentDate.getUTCFullYear(), mostRecentDate.getUTCMonth(), mostRecentDate.getUTCDate(), mostRecentDate.getUTCHours(), mostRecentDate.getUTCMinutes(), mostRecentDate.getUTCSeconds());
                    maxDate = Date.UTC(apiLastDate.getUTCFullYear(), apiLastDate.getUTCMonth(), apiLastDate.getUTCDate(), apiLastDate.getUTCHours(), apiLastDate.getUTCMinutes(), apiLastDate.getUTCSeconds());

                    break;
                default:
                    throw 'Provided type is not supported. Type: ' + type;
            }

            plugin.comparisonChartInstance.xAxis[0].setExtremes(
                minDate,
                maxDate,
                true,//renderChart,
                false
            );
        },

        /**
         * Renders the comparison chart for the symbols
         */
        _renderComparisonChart: function (symbols) {
            if (symbols == null || symbols.length == 0)
                return;

            var plugin = this;
            var etfsData = plugin._viewModel.etfs();
            plugin._viewModel.displayComparisonChart(true);

            var chartIsReturnsChart = plugin._viewModel.selectedComparisonChartType() === 'returns';
            var chartSymbols = symbols.filter(function (x) { return !inovestor.ms.core.isNullOrUndefined(x.symbol) && x.isValidTicker; });

            // If the chart is in returns mode, we only display symbols that have returns (which means more than a year of data)
            if (chartIsReturnsChart) {
                chartSymbols = chartSymbols.filter(function (x) {
                    // Map the symbol on the etfsData to the symbol in the symbols array and get the hasReturns property to determine if we should display it
                    var data = etfsData.filter(function (y) { return y.symbol === x.symbol; })[0];
                    if (!inovestor.ms.core.isNullOrUndefined(data))
                        return data.hasReturns;
                    else
                        return false;
                });
            }

            var chartIsInCompareMode = chartIsReturnsChart || chartSymbols.length > 1;

            var defaultChartOptions = {
                chart: {
                    type: 'line',
                    zoomType: 'x',
                    events: {
                        selection: function (event) {
                            if (!event.xAxis) {
                                setTimeout(function () {
                                    plugin._setChartExtremes(plugin._viewModel.selectedComparisonChartPeriod(), plugin._viewModel.selectedComparisonChartPeriodLength());
                                }, 1);
                            }
                        }
                    }
                },
                plotOptions: {
                    line: {
                        marker: {
                            enabled: false
                        }
                    },
                    series: {
                        marker: {
                            enabled: false
                        }
                    }
                },
                xAxis: {
                    type: 'datetime'
                },
                plotOptions: {
                    series: {
                        compare: chartIsInCompareMode ? 'percent' : null,
                        compareStart: true,
                        dataGrouping: {
                            dateTimeLabelFormats: {
                                week: inovestor.ms.core.currentLanguage === 'fr' ? ['Semaine du %A %e %b %Y', '%A, %e %b', '-%A, %e %b %Y'] : ['Week from %A, %e %b %Y', '%A, %e %b', '-%A, %e %b %Y']
                            }
                        }
                    }
                },
                rangeSelector: {
                    enabled: false
                },
                navigator: {
                    enabled: false
                },
                scrollbar: {
                    enabled: false
                },
                legend: {
                    enabled: true
                }
            };

            return plugin._fetchNewComparisonChartData(chartSymbols, chartIsReturnsChart).then(function (chartDatas) {
                plugin.comparisonChartData = chartDatas;
                if (!inovestor.ms.core.isNullOrUndefined(chartDatas)) {
                    plugin._viewModel.hasChartError(false);
                    //plugin._viewModel.displayComparisonChart(true);

                    var chartSeries = [];
                    chartDatas.forEach(function (chartData) {
                        var symbolParts = chartData.symbol.split(':');
                        var ticker = symbolParts.length > 0
                            ? symbolParts[symbolParts.length - 1]
                            : chartData.symbol;

                        var compoundedValue = 10000;
                        var currentSeries = {
                            name: ticker,
                            data: (chartData.historicalDatas && Array.isArray(chartData.historicalDatas))
                                ? chartData.historicalDatas.reduce(function (agg, x) {
                                var value = chartIsReturnsChart
                                    ? compoundedValue * (1 + x.value)
                                    : x.value;
                                agg.push([new Date(x.date).getTime(), value]);
                                compoundedValue = value;
                                return agg;
                            }, []) : [],
                        };

                        chartSeries.push(currentSeries);
                    });

                    var chartElement = plugin.$element.find('.comparison-chart');
                    var chartOptions = $.extend({}, defaultChartOptions, {
                        series: chartSeries,
                        yAxis: {
                            opposite: true,
                            labels: {
                                formatter: function () {
                                    if (chartIsInCompareMode) {
                                        return (this.value > 0 ? ' + ' : '') + this.value + '%';
                                    } else {
                                        return Highcharts.numberFormat(this.value, 2);
                                    }
                                }
                            }
                        },
                        tooltip: {
                            pointFormat: chartIsInCompareMode ? '<div><span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.change}%)</div>' : '<div><span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b></div>',
                            changeDecimals: 2,
                            valueDecimals: 2,
                            dateTimeLabelFormats: {
                                hour: '%A, %e %b %Y',
                                week: inovestor.ms.core.currentLanguage === 'fr' ? 'Semaine du %A %e %b %Y' : 'Week from %A, %e %b %Y'
                            }
                        }
                    });
                    chartElement.highcharts('StockChart', chartOptions);
                    plugin.comparisonChartInstance = chartElement.highcharts();

                    // Reset the extremes in case a zoom level was set
                    plugin._setChartExtremes(plugin._viewModel.selectedComparisonChartPeriod(), plugin._viewModel.selectedComparisonChartPeriodLength());
                }
                else {
                }
            });
        },

        _fetchNewComparisonChartData: function (symbols, chartIsReturnsChart) {
            var plugin = this;

            var validSymbols = symbols
                .filter(function (x) { return !inovestor.ms.core.isNullOrUndefined(x.symbol) && x.isValidTicker; })
                .map(function (x) { return !inovestor.ms.core.isNullOrUndefined(x.symbol) ? x.symbol.toUpperCase() : ''; })
            var symbolsNotInCache = validSymbols;

            var dataCache = chartIsReturnsChart
                ? plugin.comparisonChartReturnsCache
                : plugin.comparisonChartPricesCache;

            // Check if we already have a series for the requested symbols.
            // If we do, we won't call the API again for nothing.
            if (dataCache.size > 0) {
                var symbolsInCache = Array.from(dataCache.keys());
                symbolsNotInCache = validSymbols.filter(function (x) { return symbolsInCache.indexOf(x) === -1; });

                if (symbolsNotInCache.length === 0) {
                    // Nothing to call, just return the same comparisonChartData but make sure to order it the same way as the symbols
                    var cachedData = Array.from(dataCache.values());
                    var orderedSymbols = validSymbols.map(function (symbol) {
                        return cachedData.filter(function (x) { return x.symbol.toUpperCase() === symbol; })[0];
                    });

                    return $.Deferred().resolve(orderedSymbols);
                }
            }

            // Now, call the API for the symbols that are not in cache
            var chartDataUrl = chartIsReturnsChart
                ? inovestor.ms.core.stringFormat(inovestor.ms.comparator.config.apiMonthlyReturnsRelativeUrl, { symbols: symbolsNotInCache.join(',') })
                : inovestor.ms.core.stringFormat(inovestor.ms.comparator.config.apiDailyPricesRelativeUrl, { symbols: symbolsNotInCache.join(',') });
            var options = { type: 'GET', contentType: 'application/json', error: function (error) { plugin.apiErrorHandler(error); } };

            var chartDatas = [];

            return inovestor.ms.core.ajaxApi(chartDataUrl, options)
                .then(function (aipChartDatas) {
                    for (var i = 0; i < validSymbols.length; i++) {
                        var symbol = validSymbols[i];
                        var chartData = dataCache.get(symbol);

                        if (inovestor.ms.core.isNullOrUndefined(chartData)) {
                            var aipChartData = aipChartDatas.filter(function (x) { return x.symbol.toUpperCase() === symbol; })[0];
                            chartDatas.push(aipChartData);
                            dataCache.set(symbol, aipChartData);
                        } else {
                            chartDatas.push(chartData);
                        }
                    }

                    return chartDatas;
                });
        },

        /**
         * Calls the functions to render all the pie chart sections
         */
        _renderPieCharts: function () {
            var plugin = this;
            plugin._renderAssetPieCharts();
            plugin._renderSectorPieCharts();
            plugin._renderGeographicPieCharts();
        },

        /**
         * Renders the pie charts in the Asset Allocation section
         */
        _renderAssetPieCharts: function () {
            var plugin = this;

            var notDummyEtfs = plugin._viewModel.etfs().filter(function (x) { return x.assetAllocations != null; });

            for (var i = 0; i < notDummyEtfs.length; i++) {
                var currentEtf = notDummyEtfs[i];
                var chartData = [];

                for (var j = 0; j < currentEtf.assetAllocations.length; j++) {
                    var currentAlloc = currentEtf.assetAllocations[j];
                    chartData.push({
                        y: currentAlloc.percent >= 0 ? currentAlloc.percent : currentAlloc.percent * -1, // handling of negative data sets
                        formattedY: Highcharts.numberFormat(currentAlloc.percent, 2) + ' %',
                        name: inovestor.ms.core.currentLanguage == 'fr' ? currentAlloc.nameFr : currentAlloc.nameEn
                    });
                }

                var chartConfig = plugin.options.pieChartConfig;
                chartConfig.series = [{
                    colorByPoint: true,
                    data: chartData
                }];
                $('.asset-chart-' + i).highcharts(chartConfig);
            }
        },

        /**
         * Renders the pie charts in the Sector Allocation section
         */
        _renderSectorPieCharts: function () {
            var plugin = this;

            var notDummyEtfs = plugin._viewModel.etfs().filter(function (x) { return x.sectorAllocations != null; });

            for (var i = 0; i < notDummyEtfs.length; i++) {
                var currentEtf = notDummyEtfs[i];
                var chartData = [];

                for (var j = 0; j < currentEtf.sectorAllocations.length; j++) {
                    var currentAlloc = currentEtf.sectorAllocations[j];
                    chartData.push({
                        y: currentAlloc.percent >= 0 ? currentAlloc.percent : currentAlloc.percent * -1, // handling of negative data sets
                        formattedY: Highcharts.numberFormat(currentAlloc.percent, 2) + ' %',
                        name: inovestor.ms.core.currentLanguage == 'fr' ? currentAlloc.descriptionFr : currentAlloc.descriptionEn
                    });
                }

                var chartConfig = plugin.options.pieChartConfig;
                chartConfig.series = [{
                    colorByPoint: true,
                    data: chartData
                }];
                $('.sector-chart-' + i).highcharts(chartConfig);
            }
        },

        /**
         * Renders the pie charts in the Geographic Allocation section
         */
        _renderGeographicPieCharts: function () {
            var plugin = this;

            var notDummyEtfs = plugin._viewModel.etfs().filter(function (x) { return x.geographicAllocations != null; });

            for (var i = 0; i < notDummyEtfs.length; i++) {
                var currentEtf = notDummyEtfs[i];
                var chartData = [];

                for (var j = 0; j < currentEtf.geographicAllocations.length; j++) {
                    var currentAlloc = currentEtf.geographicAllocations[j];
                    chartData.push({
                        y: currentAlloc.percent >= 0 ? currentAlloc.percent : currentAlloc.percent * -1, // handling of negative data sets
                        formattedY: Highcharts.numberFormat(currentAlloc.percent, 2) + ' %',
                        name: inovestor.ms.core.currentLanguage == 'fr' ? currentAlloc.countryNameFr : currentAlloc.countryNameEn
                    });
                }

                var chartConfig = plugin.options.pieChartConfig;
                chartConfig.series = [{
                    colorByPoint: true,
                    data: chartData
                }];
                $('.geographic-chart-' + i).highcharts(chartConfig);
            }
        },

        /**
         * Set up the jQuery Autocomplete for the ticker input boxes
         */
        _setUpAutocomplete: function (counter) {
            var plugin = this;
            if (inovestor.ms.core.isNullOrUndefined(counter)) {
                counter = 0;
            }
            
            if (counter < 10) {
                // Let widget js have time to download and load before using it
                setTimeout(function () {
                    // Configure the search base url
                    if (inovestor.ms.core.isNullOrUndefined(inovestor.ms.autocomplete)) {
                        plugin._setUpAutocomplete(++counter);
                    } else {
                        var config = inovestor.ms.autocomplete.config;
                        if (inovestor.ms.core.isNullOrUndefined(config.apiSearchBaseUrl))
                            config.apiSearchBaseUrl = inovestor.ms.core.concatUrl(inovestor.ms.core.config.apiBaseUrl, "/search/suggest");

                        var globalCoreConfig = inovestor.ms.core.getComponentConfigurations ? inovestor.ms.core.getComponentConfigurations('inoMsAutocomplete', 'inoMsComparator') : {};

                        var $input = $('#etf-comparison-autocomplete');

                        // Autocomplete config
                        $input.inoMsAutocomplete(
                            $.extend({
                                language: inovestor.ms.core.currentLanguage,
                                shouldRenderMoreResults: false,
                                shouldSelectOnNonMatch: false,
                                shouldAutoSelect: true,
                                onSelect: function (item) {
                                    plugin._viewModel.addSymbol(this);
                                    $input.val('');
                                },
                                filters: {
                                    category: 'etf,fund',
                                    exchange: 'tsx,cboeca,fund'
                                }
                            }, globalCoreConfig)
                        ).on('click', function (e) {
                            e.stopPropagation();
                        });

                        $input.on("autocompleteopen", function (event, ui) {
                            $('.ino-ms-autocomplete-menu').css("width", $input.outerWidth() + "px");
                        });

                        // Select all the text in an input when it gets focused
                        $('.ino-etf-tickerbox-input').click(function () {
                            $(this).select();
                        });
                    }
                }, 200);
            }
        },

        // Update resources
        update: function () {
            var plugin = this;
            // Update view model resources
            plugin._viewModel.updateResources();
            plugin._viewModel.etfs.valueHasMutated();

            // Force Knockout to refresh our observable arrays
            var rows = plugin._viewModel.rows();
            plugin._viewModel.rows([]);
            plugin._viewModel.rows(rows);
        },

        // Chart error handler
        chartErrorHandler: function (error) {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }

            plugin._viewModel.hasChartError(true);
        },

        // Applies knockout bindings to element. (Should be done only once)
        bindModel: function () {
            var plugin = this;
            ko.applyBindings(plugin._viewModel, plugin.element);
        },
    });

    // JQuery Plugin wrapper
    $.fn.inoMsComparator = function (options) {
        this.each(function () {
            if (!$.data(this, pluginName)) {
                // Store instance of plugin in "$.data"
                $.data(this, pluginName, new Plugin(this, options));
            }
        });

        // return plugin to support JQuery chaining
        return this;
    };
    $.fn.inoMsComparator.defaults = {
        symbols: null,
        onError: null,
        onReady: null,
        templatePaths: {
            comparator: null
        },
        defaultValueString: '-',
        maxSymbols: 5,
        redirectUrl: null,
        sponsoredFamilies: [],
        pdfReportUrl: null,
        pdfHandler: null,
        pieChartConfig: {
            chart: {
                type: 'pie'
            },
            colors: ["#5089a8", "#10b292", "#ef8348", "#f0b922", "#de5b49", "#000"],
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            legend: {
                enabled: false
            }
        }
    };

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function ($, inovestor, undefined) {
    inovestor.ms.comparator = inovestor.ms.comparator || {};

    inovestor.ms.comparator.rowNames = [
        { key: 'asOf', resourceKey: 'asOf', displayType: 'date' }, 
        { key: 'currency', resourceKey: 'currency', displayType: 'text' }, 
        { key: 'previousClose', fundKey: 'previousNavps', resourceKey: 'previousClose', displayType: 'currency' }, 
        { key: 'assetUnderManagement', resourceKey: 'assetUnderManagement', displayType: 'currency' }, 
        { key: 'assetClassName', resourceKey: 'assetClassName', displayType: 'localizedText' }, 
        { key: 'managementFee', resourceKey: 'managementFee', displayType: 'percentage', valueAsPercent: true },
        { key: 'managementExpenseRatio', resourceKey: 'managementExpenseRatio', displayType: 'percentage', valueAsPercent: true }, 
        { key: 'distributionFrequencyCode', resourceKey: 'distributionFrequencyCode', displayType: 'resourceText' }, 
        { key: 'riskRating', resourceKey: 'riskRating', displayType: 'resourceText' }, 
        { key: 'inceptionDate', resourceKey: 'inceptionDate', displayType: 'date' }, 
        { key: 'marketPrice', resourceKey: 'marketPrice', displayType: 'currency' },
        { key: 'distributionYieldTtm', resourceKey: 'distributionYieldTtm', displayType: 'percentage', valueAsPercent: true },
        { key: 'equityFundStyle', resourceKey: 'equityFundStyle', displayType: 'resourceText' },
        { key: 'fundgrade', resourceKey: 'fundgrade', displayType: 'text' },
        { key: 'numberOfHoldings', resourceKey: 'numberOfHoldings', displayType: 'number', decimalPlaces: 0, showAsLargeNumber: false },
        { key: 'objective', resourceKey: 'objective', displayType: 'localizedModalText', linkTextResourceKey: 'viewObjective' },
        { key: 'averageMaturity', resourceKey: 'averageMaturity', displayType: 'number', decimalPlaces: 2 },
        { key: 'yieldToMaturity', resourceKey: 'yieldToMaturity', displayType: 'percentage', valueAsPercent: true },
        { key: 'averageCreditQuality', resourceKey: 'averageCreditQuality', displayType: 'resourceText' },
        { key: 'standardDeviationY3', resourceKey: 'standardDeviationY3', displayType: 'percentage' },
        { key: 'standardDeviationY5', resourceKey: 'standardDeviationY5', displayType: 'percentage' },
        { key: 'sharpeRatioY3', resourceKey: 'sharpeRatioY3', displayType: 'number', decimalPlaces: 2 },
        { key: 'sharpeRatioY5', resourceKey: 'sharpeRatioY5', displayType: 'number', decimalPlaces: 2 }
    ]

    inovestor.ms.comparator.overviewRows = [
        'asOf',
        'marketPrice',
        'previousClose',
        'currency',
        'assetUnderManagement',
        'distributionYieldTtm',
        'distributionFrequencyCode',
        'managementFee',
        'managementExpenseRatio',
        'riskRating',
        'equityFundStyle',
        'fundgrade',
        'numberOfHoldings',
        'inceptionDate',
        'assetClassName',
        'objective'
    ]

    inovestor.ms.comparator.riskRows = [
        'standardDeviationY3',
        'standardDeviationY5',
        'sharpeRatioY3',
        'sharpeRatioY5'
    ]

    inovestor.ms.comparator.fixedIncomeRows = [
        'averageCreditQuality',
        'yieldToMaturity',
        'averageMaturity'
    ]
})(inovestor.ms.libRef.jQuery, inovestor);
ko.bindingHandlers.accessibleClick = {
    update: function (element) {
        element.addEventListener('keydown', function (event) {
            if (event.keyCode === 13 || event.keyCode === 32) {
                event.preventDefault()
                element.click()
            }
        })
    }
}
; (function ($, inovestor, undefined) {
    inovestor.ms.comparator.resources = inovestor.ms.comparator.resources || {};
    inovestor.ms.comparator.resources["en"] = {
        pluginTitle: 'ETF Comparison',
        rowNames: {
            name: 'Name',
            symbol: 'Symbol',
            assetUnderManagement: 'AUM',
            assetClassName: 'Asset Class',
            currency: 'Base Currency',
            distributionFrequencyCode: 'Distribution Frequency',
            asOf: 'As Of',
            inceptionDate: 'Inception',
            managementExpenseRatio: 'MER',
            managementFee: 'Management Fee',
            previousClose: 'Previous Close / NAV', 
            riskRating: 'Risk Rating',
            marketPrice: 'Market Price',
            distributionYieldTtm: 'Distribution Yield (TTM)',
            equityFundStyle: 'Equity Fund Style',
            fundgrade: 'Fund Grade',
            numberOfHoldings: 'Number of Holdings',
            objective: 'Objective',
            averageMaturity: 'Average Maturity (In Years)',
            yieldToMaturity: 'YTM',
            averageCreditQuality: 'Credit Quality',
            standardDeviationY3: 'Standard Deviation 3Y',
            standardDeviationY5: 'Standard Deviation 5Y',
            sharpeRatioY3: 'Sharpe Ratio 3Y',
            sharpeRatioY5: 'Sharpe Ratio 5Y'
        },
        rowTooltips: {
            distributionYieldTtm: "TTM Distribution Yield refers to trailing twelve months distribution divided by the previous day close."
        },
        sectionLabels: {
            overview: 'Overview',
            description: 'Description',
            performance: 'Performance',
            assetAllocation: "Asset Allocation",
            geographicAllocation: "Geographic Allocation",
            sectorAllocation: "Sector Allocation",
            periodicReturns: "Periodic Returns",
            calendarReturns: "Calendar Returns",
            allocations: "Allocations",
            constituentsAllocation: "Constituents",
            characteristics: "Characteristics",
            risk: "Risk",
            fixedIncome: "Fixed Income",
            objectives: "Objectives",
            asOfPerfomance: "As of"
        },
        periodicReturnsLabels: {
            oneMonth: '1M',
            threeMonth: '3M',
            sixMonth: '6M',
            oneYear: '1Y',
            threeYear: '3Y*',
            fiveYear: '5Y*',
            tenYear: '10Y*',
            sinceInception: 'Inception*',
            yearToDate: 'YTD'
        },
        periodicReturnsCsvLabels: {
            oneMonth: '1M',
            threeMonth: '3M',
            sixMonth: '6M',
            oneYear: '1Y',
            threeYear: '3Y',
            fiveYear: '5Y',
            tenYear: '10Y',
            sinceInception: 'Inception',
            yearToDate: 'YTD'
        },
        calendarReturnsLabels: '{year} Return (Quartile)',
        calendarReturnsCsvLabels: '{year} Return',
        calendarReturnsQuartileCsvLabels: '{year} Quartile',
        allocationCsvLabels: {
            assetClass: 'Asset Class',
            constituent: 'Constituent',
            sector: 'Sector',
            geographic: 'Geographic'
        },
        columnData: {
            boolean: {
                'true': 'Yes',
                'false': 'No'
            },
            distributionFrequencyCode: {
                none: 'None',
                monthly: 'Monthly',
                quarterly: 'Quarterly',
                semiannual: 'Semi Annual',
                daily: 'Daily',
                specific: 'Specific',
                annually: 'Annually',
                weekly: 'Weekly'
            },
            riskRating: {
                none: 'None',
                low: 'Low',
                lowtomedium: 'Low to Medium',
                medium: 'Medium',
                mediumtohigh: 'Medium to High',
                high: 'High'
            }, 
            averageCreditQuality: { 
                low: 'Low',
                medium: 'Medium',
                high: 'High'
            },
            equityFundStyle: { 
                'large value': 'Large Value', 
                'large blend': 'Large Blend', 
                'mid blend': 'Mid Blend', 
                'mid growth': 'Mid Growth', 
                'mid value': 'Mid Value',
                'small blend': 'Small Blend',
                'small growth': 'Small Growth',
                'small value': 'Small Value'
            }
        },
        close: 'Close',
        enterETF: 'Enter ETFs:',
        errors: {
            symbolError: 'The following symbols are not valid:',
            duplicateSymbol: 'Value must be unique',
            invalidSymbol: 'Value is not a valid symbol',
            tooManySymbols: 'Number of values cannot exceed {maxSymbols}'
        },
        compare: 'Compare',
        addFunds: 'Add Funds',
        yes: 'Yes',
        dataNotAvailable: 'Data is not available',
        no: 'No',
        searchPlaceholder: 'Search: ETFs, mutual funds...',
        differentCategoryWarning: 'Comparing funds from different categories may not provide complete or accurate results',
        sameETFWarning: 'Please select unique values to compare',
        validETF: 'Please select a valid ETF',
        fund: 'Fund',
        returnIsAnnualizedWarning: '*Return is annualized, chart data is cumulative.',
        dataNotAvailableForETFWithLessThanAFullYear: 'No data is shown for ETF with less than a full year.',
        viewObjective: 'View Objective',
        view: 'View',
        comparisonTool: 'Comparison Tool',
        downloadComparison: 'Download',
        shareComparison: 'Share',
        url: 'URL:',
        urlCopied: 'URL Copied',
        comparisonChart: {
            periodTitle: 'Periods',
            periods: {
                ytd: 'YTD',
                oneYear: '1Y',
                threeYear: '3Y',
                fiveYear: '5Y',
                tenYear: '10Y',
                all: 'All',
                commonInception: 'Common Inception'
            },
            chartTypes: {
                returns: 'Total Return',
                prices: 'Price Return'
            }
        },
        constituentsWarning: "The portfolio holdings are subject to change without notice and may only represent a small percentage of portfolio holdings. They are not recommendations to buy or sell any particular security.",
        removeSymbol: 'Remove symbol',
        addSymbol: 'Add symbol',
        hideShowSection: 'Hide or show the section',
        asOfToolTipText: 'Indicates the last update for the market price.'
    };
})(jQuery, inovestor);
; (function ($, inovestor, undefined) {
    inovestor.ms.comparator.resources = inovestor.ms.comparator.resources || {};
    inovestor.ms.comparator.resources["fr"] = {
        pluginTitle: 'ETF Comparison',
        rowNames: {
            name: 'Nom',
            symbol: 'Symbole',
            assetUnderManagement: 'Actifs sous gestion',
            assetClassName: 'Classe d\'actifs',
            currency: 'Devise de base',
            distributionFrequencyCode: 'Fréquence de distribution',
            asOf: 'En date du',
            inceptionDate: 'Création',
            managementExpenseRatio: 'RFG',
            managementFee: 'Frais de gestion',
            previousClose: 'Clôture / NAV',
            riskRating: 'Évaluation des risques',
            marketPrice: 'Prix de clôture',
            distributionYieldTtm: 'Rendement des distributions (DDM)',
            equityFundStyle: "Style de gestion d'action",
            fundgrade: 'FundGrade',
            numberOfHoldings: 'Nombre de titres',
            objective: 'Objectif',
            averageMaturity: 'Maturité moyenne (en années)',
            yieldToMaturity: "Rendement à l'échéance", 
            averageCreditQuality: 'Qualité de crédit',
            standardDeviationY3: 'Écart-type 3A',
            standardDeviationY5: 'Écart-type 5A',
            sharpeRatioY3: 'Ratio de Sharpe 3A',
            sharpeRatioY5: 'Ratio de Sharpe 5A' 
        },
        rowTooltips: {
            distributionYieldTtm: "Rendement des distributions sur 12 mois (TTM) fait référence à la distribution des douze derniers mois, divisée par la clôture de la veille."
        },
        sectionLabels: {
            overview: 'Vue d\'ensemble',
            description: 'Description',
            performance: 'Rendement',
            assetAllocation: "Répartition d'actifs",
            geographicAllocation: "Répartition géographique",
            sectorAllocation: "Répartition sectorielle",
            periodicReturns: "Rendements périodiques",
            calendarReturns: "Rendements par année civile",
            allocations: "Répartition", 
            constituentsAllocation: "Composantes",
            characteristics: "Caractéristiques",
            risk: "Risque",
            fixedIncome: "Revenu fixe",
            objectives: "Objectifs",
            asOfPerfomance: 'En date du'
        },
        periodicReturnsLabels: {
            oneMonth: '1M',
            threeMonth: '3M',
            sixMonth: '6M',
            oneYear: '1A',
            threeYear: '3A*',
            fiveYear: '5A*',
            tenYear: '10A*',
            sinceInception: 'Création*',
            yearToDate: 'AACJ'
        },
        periodicReturnsCsvLabels: {
            oneMonth: '1M',
            threeMonth: '3M',
            sixMonth: '6M',
            oneYear: '1A',
            threeYear: '3A',
            fiveYear: '5A',
            tenYear: '10A',
            sinceInception: 'Création',
            yearToDate: 'AACJ'
        },
        calendarReturnsLabels: '{year} Rendement (Quartile)', 
        calendarReturnsCsvLabels: '{year} Rendement',
        calendarReturnsQuartileCsvLabels: '{year} Quartile',
        allocationCsvLabels: {
            assetClass: "Classe d'actif",
            constituent: 'Componsante',
            sector: 'Secteur',
            geographic: 'Géographique'
        },
        columnData: {
            boolean: {
                'true': 'Oui',
                'false': 'Non'
            },
            distributionFrequencyCode: {
                none: 'Aucune',
                monthly: 'Mensuelle',
                quarterly: 'Trimestrielle',
                semiannual: 'Semi-annuelle',
                daily: 'Du quotidien',
                specific: 'Spécifique',
                annually: 'Annuellement',
                weekly: 'Hebdomadaire'
            },
            riskRating: {
                none: 'Aucun',
                low: 'Bas',
                lowtomedium: 'Bas à moyen',
                medium: 'Moyen',
                mediumtohigh: 'Moyen à élevé',
                high: 'Haute'
            },
            averageCreditQuality: { 
                low: 'Bas',
                medium: 'Moyen',
                high: 'Haute'
            },
            equityFundStyle: { 
                'large growth': 'Grande Cap. Croissance', 
                'large value': 'Grande Cap. Valeur', 
                'large blend': 'Grande Cap. Combinée', 
                'mid blend': 'Moyenne Cap. Combinée', 
                'mid growth': 'Moyenne Cap. Croissance', 
                'mid value': 'Moyenne Cap. Valeur',
                'small blend': 'Petite Cap. Combinée',
                'small growth': 'Petite Cap. Croissance',
                'small value': 'Petite Cap. Valeur'
            }
        },
        close: 'Fermer',
        enterETF: 'Entrez un FNB:',
        errors: {
            symbolError: 'Les symboles suivants ne sont pas valides:',
            duplicateSymbol: 'La valeur doit être unique',
            invalidSymbol: 'La valeur n\'est pas un symbole valide',
            tooManySymbols: 'Le nombre de valeurs ne peut pas dépasser {maxSymbols}'
        },
        compare: 'Comparer',
        addFunds: 'Ajouter des fonds',
        yes: 'Oui',
        dataNotAvailable: 'Les données ne sont pas disponibles',
        no: 'Non',
        searchPlaceholder: 'Recherche: FNB, fonds communs...',
        differentCategoryWarning: 'Comparer les fonds de différentes catégories peut ne pas fournir des résultats complets ou précis',
        sameETFWarning: 'Veuillez sélectionner des valeurs uniques pour comparer',
        validETF: 'Veuillez sélectionner un FNB valide',
        fund: 'Fond',
        returnIsAnnualizedWarning: '*Le rendement est annualisé, les données du graphique sont cumulatives.', 
        dataNotAvailableForETFWithLessThanAFullYear: "Aucune donnée n'est affichée pour les FNB ayant moins d'une année complète.",
        viewObjective: 'Objectif',
        view: 'Voir',
        comparisonTool: 'Outil de comparaison',
        downloadComparison: 'Télécharger',
        shareComparison: 'Partager',
        url: 'URL : ',
        urlCopied: 'URL copiée',
        comparisonChart: {
            periodTitle: 'Périodes',
            periods: {
                ytd: 'Année',
                oneYear: '1A',
                threeYear: '3A',
                fiveYear: '5A',
                tenYear: '10A',
                all: 'Max',
                commonInception: 'Incep. commune'
            },
            chartTypes: {
                returns: 'Rendement total',
                prices: 'Rendement sur le prix'
            }
        },
        constituentsWarning: "Les titres du portefeuille peuvent changer sans préavis et ne représentent qu'un faible pourcentage des titres en portefeuille. Ces renseignements ne constituent pas une recommandation d'achat ou de vente d'un titre particulier.",
        removeSymbol: 'Supprimer le symbole',
        addSymbol: 'Ajouter un symbole',
        hideShowSection: 'Afficher ou cacher la section',
        asOfToolTipText: 'Indique la dernière mise à jour du prix du marché.'
    };
})(jQuery, inovestor);
; (function ($, inovestor, undefined) {
    inovestor.ms.comparator = inovestor.ms.comparator || {};

    inovestor.ms.comparator.csvArrayBuilder = function () {
        var columns = []

        this.addColumn = function (header, getter) {
            columns.push({ header: header, getter: getter })
            return this
        }

        this.addColumnsFactory = function (fn) {
            columns.push(fn)
            return this
        }

        this.build = function (data) {
            var interpretedColumns = columns.reduce(function (agg, column) {
                if (typeof column === 'function') {
                    var createdColumns = column(data)
                    if (createdColumns != null) {
                        createdColumns.forEach(function (x) {
                            agg.push(x)
                        })
                    }
                } else {
                    agg.push(column)
                }
                return agg
            }, [])

            var rows = []

            rows.push(interpretedColumns.map(function (column) {
                return column.header
            }))

            data.forEach(function (x) {
                rows.push(interpretedColumns.map(function (column) {
                    return column.getter(x)
                }))
            })

            return rows
        }
    }
})(inovestor.ms.libRef.jQuery, inovestor);
; (function ($, inovestor, undefined) {
    inovestor.ms.comparator = inovestor.ms.comparator || {};

    inovestor.ms.comparator.csvService = {
        transformCsvArrayToCsvString: function (csvArray, options) {
            var csvString = csvArray.map(function (x, i) {
                // don't escape header row
                if (options != null && options.escapeHeader === false && i === 0) return x.join(',')

                return x.map(function (y) {
                    if (y == null) return ''
                    if (typeof y === 'string' && y !== '') return '"' + y.replace(/"/g, '""') + '"'
                    return y
                }).join(',')
            }).join('\r\n')

            return csvString
        },

        transformComparatorDataToCsvArray: function (data, resources) {
            return new inovestor.ms.comparator.csvArrayBuilder()
                // hardcoded identifier columns
                .addColumn(resources.rowNames.name, function (x) { return localizeText(x.nameEn, x.nameFr) })
                .addColumn(resources.rowNames.symbol, function (x) { return x.symbol })
                // overview characteristics columns
                .addColumnsFactory(function () {
                    return inovestor.ms.comparator.overviewRows.map(function (x) { return makeOverviewRowToCsvColumn(x, resources) })
                })
                // overview risk columns
                .addColumnsFactory(function () {
                    return inovestor.ms.comparator.riskRows.map(function (x) { return makeOverviewRowToCsvColumn(x, resources) })
                })
                // overview fixed income columns
                .addColumnsFactory(function () {
                    return inovestor.ms.comparator.fixedIncomeRows.map(function (x) { return makeOverviewRowToCsvColumn(x, resources) })
                })
                // periodic returns columns
                .addColumn(resources.periodicReturnsCsvLabels.yearToDate, function (x) { return x.periodicReturns == null ? null : x.periodicReturns.yearToDate })
                .addColumn(resources.periodicReturnsCsvLabels.oneMonth, function (x) { return x.periodicReturns == null ? null : x.periodicReturns.oneMonth })
                .addColumn(resources.periodicReturnsCsvLabels.threeMonth, function (x) { return x.periodicReturns == null ? null : x.periodicReturns.threeMonth })
                .addColumn(resources.periodicReturnsCsvLabels.sixMonth, function (x) { return x.periodicReturns == null ? null : x.periodicReturns.sixMonth })
                .addColumn(resources.periodicReturnsCsvLabels.oneYear, function (x) { return x.periodicReturns == null ? null : x.periodicReturns.oneYear })
                .addColumn(resources.periodicReturnsCsvLabels.threeYear, function (x) { return x.periodicReturns == null ? null : x.periodicReturns.threeYear })
                .addColumn(resources.periodicReturnsCsvLabels.fiveYear, function (x) { return x.periodicReturns == null ? null : x.periodicReturns.fiveYear })
                .addColumn(resources.periodicReturnsCsvLabels.tenYear, function (x) { return x.periodicReturns == null ? null : x.periodicReturns.tenYear })
                .addColumn(resources.periodicReturnsCsvLabels.sinceInception, function (x) { return x.periodicReturns == null ? null : x.periodicReturns.sinceInception })
                // calendar returns columns
                .addColumnsFactory(function () {
                    var distinctYears = data.reduce(function (agg, x) {
                        if (x.calendarReturns != null) {
                            x.calendarReturns.forEach(function (y) {
                                if (!agg.includes(y.year)) {
                                    agg.push(y.year)
                                }
                            })
                        }
                        return agg
                    }, [])

                    return distinctYears.reduce(function (agg, year) {
                        agg.push({ header: inovestor.ms.core.stringFormat(resources.calendarReturnsCsvLabels, { year: year }), getter: function (x) { 
                            if (x.calendarReturns == null) return null
                            var calendarReturn = x.calendarReturns.find(function (y) { return y.year === year })
                            return calendarReturn == null ? null : calendarReturn.return
                         }})

                        agg.push({ header: inovestor.ms.core.stringFormat(resources.calendarReturnsQuartileCsvLabels, { year: year }), getter: function (x) {
                            if (x.calendarReturns == null) return null
                            var calendarReturn = x.calendarReturns.find(function (y) { return y.year === year })
                            return calendarReturn == null ? null : calendarReturn.quartileRank
                        }})

                        return agg
                    }, [])
                })
                // asset allocation columns
                .addColumnsFactory(function () {
                    var highestNumberOfAssetAllocation = data.reduce(function (agg, x) {
                        if (x.assetAllocations == null) return agg
                        return Math.max(agg, x.assetAllocations.length)
                    }, 0)

                    if (highestNumberOfAssetAllocation === 0) return []

                    var columns = []

                    for (var i = 0; i < highestNumberOfAssetAllocation; i++) {
                        columns.push({ 
                            header: resources.allocationCsvLabels.assetClass + ' ' + (i + 1), 
                            getter: (function (index) {
                                return function (x) {
                                    return x.assetAllocations == null || x.assetAllocations[index] == null ? null : localizeText(x.assetAllocations[index].nameEn, x.assetAllocations[index].nameFr) 
                                }
                            })(i)
                        })

                        columns.push({
                            header: resources.allocationCsvLabels.assetClass + ' ' + (i + 1) + ' (%)', 
                            getter: (function (index) {
                                return function (x) {
                                    return x.assetAllocations == null || x.assetAllocations[index] == null ? null : x.assetAllocations[index].percent
                                }
                            })(i)
                        })
                    }

                    return columns
                })
                // geographic allocation columns
                .addColumnsFactory(function () {
                    var highestNumberOfGeographicAllocation = data.reduce(function (agg, x) {
                        if (x.geographicAllocations == null) return agg
                        return Math.max(agg, x.geographicAllocations.length)
                    }, 0)

                    if (highestNumberOfGeographicAllocation === 0) return []

                    var columns = []

                    for (var i = 0; i < highestNumberOfGeographicAllocation; i++) {
                        columns.push({
                            header: resources.allocationCsvLabels.geographic + ' ' + (i + 1), 
                            getter: (function (index) {
                                return function (x) {
                                    return x.geographicAllocations == null || x.geographicAllocations[index] == null ? null : localizeText(x.geographicAllocations[index].countryNameEn, x.geographicAllocations[index].countryNameFr)
                                }
                            })(i)
                        })

                        columns.push({
                            header: resources.allocationCsvLabels.geographic + ' ' + (i + 1) + ' (%)', 
                            getter: (function (index) {
                                return function (x) {
                                    return x.geographicAllocations == null || x.geographicAllocations[index] == null ? null : x.geographicAllocations[index].percent
                                }
                            })(i)
                        })
                    }

                    return columns
                })
                // sector allocation columns
                .addColumnsFactory(function () {
                    var highestNumberOfSectorAllocation = data.reduce(function (agg, x) {
                        if (x.sectorAllocations == null) return agg
                        return Math.max(agg, x.sectorAllocations.length)
                    }, 0)

                    if (highestNumberOfSectorAllocation === 0) return []

                    var columns = []

                    for (var i = 0; i < highestNumberOfSectorAllocation; i++) {
                        columns.push({
                            header: resources.allocationCsvLabels.sector + ' ' + (i + 1), 
                            getter: (function (index) {
                                return function (x) {
                                    return x.sectorAllocations == null || x.sectorAllocations[index] == null ? null : localizeText(x.sectorAllocations[index].descriptionEn, x.sectorAllocations[index].descriptionFr)
                                }
                            })(i)
                        })

                        columns.push({
                            header: resources.allocationCsvLabels.sector + ' ' + (i + 1) + ' (%)', 
                            getter: (function (index) {
                                return function (x) {
                                    return x.sectorAllocations == null || x.sectorAllocations[index] == null ? null : x.sectorAllocations[index].percent
                                }
                            })(i)
                        })
                    }

                    return columns
                })
                // constituents columns
                .addColumnsFactory(function () {
                    var highestNumberOfConstituentsAllocation = data.reduce(function (agg, x) {
                        if (x.holdings == null) return agg
                        return Math.max(agg, x.holdings.length)
                    }, 0)

                    if (highestNumberOfConstituentsAllocation === 0) return []

                    var columns = []

                    for (var i = 0; i < highestNumberOfConstituentsAllocation; i++) {
                        columns.push({
                            header: resources.allocationCsvLabels.constituent + ' ' + (i + 1), 
                            getter: (function (index) {
                                return function (x) {
                                    return x.holdings == null || x.holdings[index] == null ? null : localizeText(x.holdings[index].nameEn, x.holdings[index].nameFr)
                                }
                            })(i)
                        })

                        columns.push({
                            header: resources.allocationCsvLabels.constituent + ' ' + (i + 1) + ' (%)', 
                            getter: (function (index) {
                                return function (x) {
                                    return x.holdings == null || x.holdings[index] == null ? null : x.holdings[index].weight
                                }
                            })(i)
                        })
                    }

                    return columns
                })
                .build(data)
        }
    }

    function makeOverviewRowToCsvColumn (field, resources) {
        var rowName = inovestor.ms.comparator.rowNames.find(function (x) { return x.key === field })

        if (rowName == null) {
            return { header: field, getter: function () { return null } }
        }

        var header = rowName.resourceKey == null || resources.rowNames == null || resources.rowNames[rowName.resourceKey] == null ? field : resources.rowNames[rowName.resourceKey]

        var getter = function (x) {
            return x[field] == null ? null : x[field]
        }

        if (rowName.displayType === 'localizedText' || rowName.displayType === 'localizedModalText') {
            getter = function (x) {
                var localizedField = inovestor.ms.core.currentLanguage === 'fr' ? field + 'Fr' : field + 'En'
                return x[localizedField] == null ? null : x[localizedField]
            }
        } else if (rowName.displayType === 'resourceText') {
            getter = function (x) {
                var value = x[field]
                if (value == null) return null
                var localizedValue = resources.columnData[rowName.resourceKey][value.toLowerCase()]
                return localizedValue == null ? value : localizedValue
            }
        }

        return { header: header, getter: getter }
    }

    function localizeText (english, french) {
        return inovestor.ms.core.currentLanguage === 'fr' ? french : english
    }

})(inovestor.ms.libRef.jQuery, inovestor);